import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { endpoints, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Reset() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 8) {
            setError("Password must be at least 8 characters");
            return;
        }
        setBusy(true);
        setError("");
        try {
            await endpoints.authReset(token, password);
            toast.success("Password updated. Please sign in.");
            nav("/signin", { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    if (!token) {
        return (
            <div className="max-w-md mx-auto px-4 md:px-6 py-16" data-testid="reset-missing-token">
                <div className="border border-[#2a2a2a] p-8">
                    <h1 className="font-display font-black uppercase text-2xl">Invalid reset link</h1>
                    <p className="mt-2 text-sm text-[#a3a3a3]">This reset link is missing a token.</p>
                    <Link to="/forgot" className="pm-btn mt-6 inline-flex">Request a new one</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-md mx-auto px-4 md:px-6 py-16" data-testid="reset-page">
            <div className="border border-[#2a2a2a] p-8">
                <div className="text-[10px] font-mono uppercase tracking-widest text-[#ff4400]">Project Mint</div>
                <h1 className="mt-2 font-display font-black uppercase tracking-tighter text-3xl">Set a new password</h1>
                <form onSubmit={submit} className="mt-6 space-y-4">
                    <label className="block">
                        <span className="text-[10px] font-mono uppercase tracking-widest text-[#a3a3a3]">New password (min 8)</span>
                        <input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 bg-transparent border-b border-[#2a2a2a] focus:border-[#ff4400] py-2 outline-none" data-testid="reset-password" />
                    </label>
                    {error && <div className="text-xs font-mono uppercase text-[#ff3333]" data-testid="reset-error">{error}</div>}
                    <button type="submit" disabled={busy || password.length < 8} className="pm-btn pm-btn-primary w-full" data-testid="reset-submit">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                        Update password
                    </button>
                </form>
            </div>
        </div>
    );
}
